import { createAuthStore } from '@react-apps/auth';
import type { StoredAuth } from '../../domain/entities/auth.entity';

/**
 * Store de identidade deste app — a fábrica é compartilhada
 * (`@react-apps/auth`), o formato do snapshot é daqui.
 */
export const useAuthStore = createAuthStore<StoredAuth>();
